module.exports = __webpack_public_path__ + "static/media/mso.615dfde2.mp4";